import React, { useState } from 'react';
import cx from '../../../../styles';
import {gtmSend} from '../../../../helpers';

export const MultiChoicePrePoll = ({pollChoices, voteHandler, match, id, t}) => {

    const [selectedArray, setSelectedArray] = useState([]);

    const onClickHandler = (choiceId) => {
        if(selectedArray.indexOf(choiceId) === -1){
            document.getElementById(choiceId).classList.add('active');
            const newArray = selectedArray;
            newArray.push(choiceId);
            setSelectedArray(newArray);
            gtmSend('dynamic', 'Poll Card', 'click-select-multichoice', match.path);
        }
        else{
            document.getElementById(choiceId).classList.remove('active');
            const index = selectedArray.indexOf(choiceId);
            const newArray = selectedArray;
            newArray.splice(index, 1);
            setSelectedArray(newArray);
            gtmSend('dynamic', 'Poll Card', 'click-deselect-multichoice', match.path);
        }
    }

    const onSubmitHandler = () => {
        voteHandler(id, selectedArray.toString());
        gtmSend('dynamic', 'Poll Card', 'click-submit-multichoice', match.path);
    }

    return (
        <div className={cx('pre-poll-state')}>
            {
                pollChoices.map((choice) => {
                    return (
                        <div className={cx("poll-bar-row")} key={choice.id} id={choice.id}>
                            <span className={cx("checkbox-btn")} onClick={() => onClickHandler(choice.id)}></span>
                            <div title={choice.message} className={cx("poll-bar")} onClick={() => onClickHandler(choice.id)}>
                                {/*<label className={cx("redio-check")}></label>*/}
                                <span>{choice.message}</span>
                            </div>
                        </div>
                    );
                })
            }
            <button className={cx("submit-btn")} onClick={() => onSubmitHandler()}>{t("submit_vote")}</button>
        </div>
    );
}

export const MultiChoicePostPoll = ({votes}) => {
    return (
        <div className={cx('post-poll-state')}>
            {
                votes.map((vote) => {
                    return (
                        <div className={cx("poll-bar-row", vote.user_choice == 1 ? "chosen" : "")} key={vote.choice_id}>
                            <div>{vote.percentage}%</div>
                            
                            <div title={vote.message} className={cx("poll-bar")}>
                                
                                <div style={{width: vote.percentage + "%"}}></div>

                                {/*<input className={cx("hide", (vote.user_choice == 1 ? "visible" : ""))} type = "radio" defaultChecked />*/}

                                <span>{vote.message}</span>
                            </div>
                            
                        </div>
                    );
                })
            }
        </div>
    );
}
